import { Module } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

const featureFlags: Module<FeatureFlagsState, IRootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}

export default featureFlags
